<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="600px" persistent>
      <v-card>
        <v-card-title style="justify-content: center;">{{ $t('refund.refund') }}</v-card-title>
        <v-card-text class="d-flex justify-center">
          <template v-if="refundStatus === 'processing'">
            <div class="d-flex flex-column align-center">
              <v-progress-circular
                  color="primary"
                  indeterminate
                  size="100"
              >
                <v-avatar>
                  <v-img :src="terminalSVG"/>
                </v-avatar>
              </v-progress-circular>
              <span class="mt-2">
                {{ $t('refund.refundOnTerminal') }}
              </span>
            </div>
          </template>

          <template v-else-if="refundStatus === 'success'">
            <v-alert class="no-border" outlined>
              <template v-slot:prepend>
                <v-icon class="mr-2" color="green" large>
                  mdi-check-circle
                </v-icon>
              </template>
              {{ $t('refund.refundSuccess') }}
            </v-alert>
          </template>
          <template v-else>
            <v-alert class="no-border" outlined>
              <template v-slot:prepend>
                <v-icon class="mr-2" color="red" large>
                  mdi-close
                </v-icon>
              </template>
              {{ $t('refund.refundError') }}
            </v-alert>
          </template>
        </v-card-text>
        <v-card-actions v-if="['success','error'].includes(refundStatus)" class="pa-0">
          <v-btn
              v-if="refundStatus === 'error'"
              color="primary"
              style="width: 50%"
              tile
              @click="openTerminalDialog"
          >
            {{ $t('refund.reLaunch') }}
          </v-btn>
          <v-btn
              :style="refundStatus === 'error' ? 'width: 50%;' : 'width: 100%;'"
              class="ml-0"
              color="secondary"
              tile
              @click="closePaymentStatusDialog"
          >
            {{ $t('refund.closePaymentStatusDialog') }}
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else-if="refundStatus === 'processing'" class="pa-0">
          <v-btn
              color="primary"
              style="width: 50%"
              tile
              @click="openConfirmationDialog('cancel')"
          >
            {{ $t('refund.cancel') }}
          </v-btn>
          <v-btn
              :style="'width: 50%;'"
              class="ml-0"
              color="secondary"
              tile
              @click="openConfirmationDialog('validate')"
          >
            {{ $t('refund.manualValidation') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirmation-dialog
        :text="confirmText"
        :title="confirmTitle"
        :value="confirmationDialog"
        @no="closeConfirm()"
        @yes="confirm()"/>
  </v-row>
</template>

<script>
import terminalSVG from '@/components/icons/terminal.svg'
import confirmationDialog from '@/components/ConfirmationDialog'

export default {
  name: 'PaymentStatusDialog',
  components: {
    'confirmationDialog': confirmationDialog
  },
  data () {
    return {
      terminalSVG: terminalSVG,
      confirmationDialog: false,
      action: null,
      confirmTitle: null,
      confirmText: null
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    refundStatus: {
      type: String,
      default: 'processing'
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    openTerminalDialog () {
      this.$emit('openTerminalDialog')
    },
    closePaymentStatusDialog () {
      this.$emit('closePaymentStatusDialog')
    },
    confirm () {
      if (this.action === 'cancel') {
        this.$emit('cancelRefund')
      } else {
        this.$emit('manualValidation')
      }
      this.closePaymentStatusDialog()
    },
    closeConfirm () {
      this.confirmationDialog = false
    },
    openConfirmationDialog (action) {

      this.action = action
      this.confirmTitle = this.$t('refund.confirmManualValidationTitle')
      this.confirmText = this.$t('refund.confirmManualValidationText')

      if (action === 'cancel') {
        this.confirmTitle = this.$t('refund.confirmCancelRefundTitle')
        this.confirmText = this.$t('refund.confirmCancelRefundText')
      }
      this.confirmationDialog = true
    }
  }
}
</script>

<style scoped>
.v-alert--outlined {
  border: none !important;
}
</style>
